import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Job } from '../../features/Jobs/types/types';

export interface ModalState {
	jobDetailsModal: {
		isOpen: boolean;
		jobId: string | null;
		jobDetails: Job | null;
		loading: boolean;
		error: string | null;
	};
	submitJobApplicationModal: {
		isOpen: boolean;
		jobId: string | null;
		jobTitle: string | null;
		companyName: string | null;
	};
	profileCompletionModal: {
		isOpen: boolean;
	};
}

const initialState: ModalState = {
	jobDetailsModal: {
		isOpen: false,
		jobId: null,
		jobDetails: null,
		loading: false,
		error: null,
	},
	submitJobApplicationModal: {
		isOpen: false,
		jobId: null,
		jobTitle: null,
		companyName: null,
	},
	profileCompletionModal: {
		isOpen: false,
	},
};

const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		openJobDetailsModal: (state, action: PayloadAction<{ jobId: string }>) => {
			state.jobDetailsModal.isOpen = true;
			state.jobDetailsModal.jobId = action.payload.jobId;
			state.jobDetailsModal.loading = true;
			state.jobDetailsModal.error = null;
			// Close other modals
			state.submitJobApplicationModal.isOpen = false;
		},
		setJobDetails: (state, action: PayloadAction<{ jobDetails: Job | null; loading: boolean; error: string | null }>) => {
			state.jobDetailsModal.jobDetails = action.payload.jobDetails;
			state.jobDetailsModal.loading = action.payload.loading;
			state.jobDetailsModal.error = action.payload.error;
		},
		closeJobDetailsModal: (state) => {
			state.jobDetailsModal.isOpen = false;
			state.jobDetailsModal.jobId = null;
			state.jobDetailsModal.jobDetails = null;
			state.jobDetailsModal.loading = false;
			state.jobDetailsModal.error = null;
		},
		openSubmitJobApplicationModal: (state, action: PayloadAction<{ 
			jobId: string; 
			jobTitle: string; 
			companyName: string; 
		}>) => {
			state.submitJobApplicationModal.isOpen = true;
			state.submitJobApplicationModal.jobId = action.payload.jobId;
			state.submitJobApplicationModal.jobTitle = action.payload.jobTitle;
			state.submitJobApplicationModal.companyName = action.payload.companyName;
			// Close job details modal
			state.jobDetailsModal.isOpen = false;
		},
		closeSubmitJobApplicationModal: (state) => {
			state.submitJobApplicationModal.isOpen = false;
			state.submitJobApplicationModal.jobId = null;
			state.submitJobApplicationModal.jobTitle = null;
			state.submitJobApplicationModal.companyName = null;
		},
		reopenJobDetailsModal: (state) => {
			if (state.submitJobApplicationModal.jobId) {
				state.jobDetailsModal.isOpen = true;
				state.jobDetailsModal.jobId = state.submitJobApplicationModal.jobId;
				state.submitJobApplicationModal.isOpen = false;
			}
		},
		openProfileCompletionModal: (state) => {
			state.profileCompletionModal.isOpen = true;
		},
		closeProfileCompletionModal: (state) => {
			state.profileCompletionModal.isOpen = false;
		},
	},
});

export const {
	openJobDetailsModal,
	setJobDetails,
	closeJobDetailsModal,
	openSubmitJobApplicationModal,
	closeSubmitJobApplicationModal,
	reopenJobDetailsModal,
	openProfileCompletionModal,
	closeProfileCompletionModal,
} = modalSlice.actions;

export default modalSlice.reducer;
